import {
    defineMessages
} from 'react-intl';

export default defineMessages({
    dueDate: {
        id: 'billing.payment.schedule.component.Due date',
        defaultMessage: 'Due date'
    },
    amountBilled: {
        id: 'billing.payment.schedule.component.Amount billed',
        defaultMessage: 'Amount billed'
    },
    currentDue: {
        id: 'billing.payment.schedule.component.Current due',
        defaultMessage: 'Current due'
    },
    pastDue: {
        id: 'billing.payment.schedule.component.Past due',
        defaultMessage: 'Past due'
    },
    paid: {
        id: 'billing.payment.schedule.component.Paid',
        defaultMessage: 'Paid'
    }
});